import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';

import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, CheckboxComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { ModalComponent } from 'mbs-ui-kit/modal/modal.component';
import { MbsPopupType } from 'mbs-ui-kit/utils/enums/mbs-popup-enum';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { HelpLinkDirective } from 'mbs-ui-shared@help/helpLink.directive';
import { Administrator } from 'mbs-ui-shared@models';
import Computer from 'mbs-ui-shared@models/Computer';
import { ProviderService } from 'mbs-ui-shared@services/provider.service';
import { BehaviorSubject } from 'rxjs';
import { finalize, switchMap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'mbs-remote-connection-enable-modal-component',
  templateUrl: './remote-connection-enable-modal.component.html',
  styleUrls: ['./remote-connection-enable-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    NgbTooltipModule,
    HelpLinkDirective,
    I18NextPipe,
    ModalComponent,
    CheckboxComponent,
    ModalFooterDirective
  ]
})
export class RemoteConnectionEnableModalComponent implements OnInit {
  private providerService = inject(ProviderService);
  private auth = inject(AuthFacade);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;
  public readonly mbsPopupType = MbsPopupType;

  public checkbox = new FormControl(false);
  public loading$ = new BehaviorSubject(false);
  public computer: Computer;

  ngOnInit(): void {
    if (this.baseModal.data) {
      this.computer = this.baseModal.data.computer;
    }
  }

  handleSubmit(): void {
    this.loading$.next(true);
    this.providerService
      .toggleRemoteAccess(true)
      .pipe(
        switchMap(() => {
          return this.auth.fetchCurrentUser$;
        }),
        finalize(() => {
          this.loading$.next(false);
        })
      )
      .subscribe((admin: Administrator) => {
        this.baseModal.save(admin);
      });
  }
}
